var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        "padding-top": "1rem",
        "padding-bottom": ".3rem",
        "min-height": "100vh",
        background: "#fff"
      }
    },
    [
      _c("topbar", { attrs: { text: _vm.scaleInfo.title } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mainBox" },
        [
          _c("div", { staticClass: "need" }, [_vm._v("待支付")]),
          _vm._v(" "),
          _c("div", { staticClass: "price" }, [
            _vm._v("￥" + _vm._s(_vm.scaleInfo.scalePrice))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "line" }),
          _vm._v(" "),
          _c("div", { staticClass: "infoBox" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("测评订单")]),
            _vm._v(" "),
            _c("div", { staticClass: "scaleBox" }, [
              _c(
                "div",
                {
                  staticClass: "scaleLeft",
                  style: {
                    background:
                      "url(" +
                      _vm.EnvUrl +
                      _vm.scaleInfo.pic +
                      ") no-repeat center/cover"
                  }
                },
                [
                  _c("div", { staticClass: "labelName" }, [
                    _vm._v(_vm._s(_vm.scaleInfo.labelName))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "scaleRight" }, [
                _c("div", { staticClass: "scaleTitle" }, [
                  _vm._v(_vm._s(_vm.scaleInfo.title))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tagline" }, [
                  _vm._v(_vm._s(_vm.scaleInfo.tagline))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "num" }, [
                  _vm._v(_vm._s(_vm.scaleInfo.testCountStr) + "人已测试")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "payBox" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("支付方式")]),
            _vm._v(" "),
            _vm.infoTitle
              ? _c(
                  "div",
                  {
                    staticClass: "layer",
                    on: {
                      click: function($event) {
                        _vm.selectPayType(0)
                      }
                    }
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "choose",
                      class: { active: _vm.payType === 0 }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.wxPay
              ? _c(
                  "div",
                  {
                    staticClass: "layer",
                    on: {
                      click: function($event) {
                        _vm.selectPayType(1)
                      }
                    }
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "choose",
                      class: { active: _vm.payType === 1 }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              staticClass: "btn",
              on: {
                click: function($event) {
                  _vm.ruleStatus = true
                }
              }
            })
          ]),
          _vm._v(" "),
          _vm.payType === 1
            ? _c("vue-qr", {
                staticStyle: { margin: ".2rem auto", display: "block" },
                attrs: {
                  text: _vm.downloadData.url,
                  margin: 0,
                  colorDark: "#000",
                  colorLight: "#fff",
                  logoScale: 0.3,
                  size: 200
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.ruleStatus
        ? _c("div", { staticClass: "maskBox" }, [
            _c("div", { staticClass: "mask" }, [
              _c("div", { staticClass: "maskTitle" }, [_vm._v("温馨提示")]),
              _vm._v(" "),
              _c("div", { staticClass: "ms" }, [
                _vm._v("支付成功后未跳转进入测试的，请点击 "),
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.to("mytest")
                      }
                    }
                  },
                  [_vm._v("『我的测试』")]
                ),
                _vm._v("选择「已支付」的测试记录并立即测试。")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "maskLine" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "maskBtn", on: { click: _vm.ruleSure } },
                [_vm._v("我知道了")]
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "iconBox" }, [
      _c("img", { attrs: { src: require("../assets/aplipay.png"), alt: "" } }),
      _vm._v(" "),
      _c("span", [_vm._v("支付宝")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "iconBox" }, [
      _c("img", { attrs: { src: require("../assets/wxpay.png"), alt: "" } }),
      _vm._v(" "),
      _c("span", [_vm._v("微信")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c6daac8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c6daac8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/pay.vue
// module id = null
// module chunks = 